import React, { useState, useEffect } from 'react';

const API = 'http://localhost:8000/api/v1';

function Brief() {
  const [data, setData] = useState(null);
  const token = localStorage.getItem('khepri_token');

  useEffect(() => {
    fetch(API + '/khepri/brief', { headers: { Authorization: 'Bearer ' + token } })
      .then(r => r.json()).then(setData);
  }, []);

  if (!data) return <p style={{color:'#94A3B8'}}>Loading...</p>;

  return (
    <div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 10, marginBottom: 20 }}>
        <div style={{ background: '#1E293B', padding: 14, borderRadius: 8, border: '1px solid #334155', textAlign: 'center' }}>
          <div style={{ fontSize: 10, color: '#94A3B8', textTransform: 'uppercase' }}>Balance</div>
          <div style={{ fontSize: 16, fontWeight: 700 }}>{(data.balance || 0).toLocaleString()} RUB</div>
        </div>
        <div style={{ background: '#1E293B', padding: 14, borderRadius: 8, border: '1px solid #334155', textAlign: 'center' }}>
          <div style={{ fontSize: 10, color: '#94A3B8', textTransform: 'uppercase' }}>Forecast</div>
          <div style={{ fontSize: 16, fontWeight: 700, color: data.has_risk ? '#EF4444' : '#10B981' }}>{data.has_risk ? 'RISK' : 'OK'}</div>
        </div>
        <div style={{ background: '#1E293B', padding: 14, borderRadius: 8, border: '1px solid #334155', textAlign: 'center' }}>
          <div style={{ fontSize: 10, color: '#94A3B8', textTransform: 'uppercase' }}>Next Payment</div>
          <div style={{ fontSize: 14, fontWeight: 700 }}>{(data.upcoming_tax_events || [])[0]?.name?.slice(0, 15) || 'None'}</div>
        </div>
      </div>

      <h3 style={{ marginBottom: 10 }}>Tasks</h3>
      {(data.tasks || []).map(t => (
        <div key={t.id} style={{ padding: 10, marginBottom: 6, background: '#1E293B', borderRadius: 8, borderLeft: '3px solid ' + (t.priority === 'critical' ? '#EF4444' : t.priority === 'high' ? '#F59E0B' : '#6366F1'), fontSize: 13 }}>
          {t.text}
        </div>
      ))}

      {(data.risks || []).length > 0 && (
        <div style={{ marginTop: 16, padding: 12, background: 'rgba(239,68,68,0.15)', borderRadius: 8, fontSize: 14 }}>
          {data.risks[0].description}
        </div>
      )}

      <h3 style={{ marginTop: 20, marginBottom: 10 }}>Forecast 14 days</h3>
      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
        <thead><tr style={{ color: '#94A3B8' }}><th>Date</th><th>Balance</th><th>In</th><th>Out</th><th>Risk</th></tr></thead>
        <tbody>
          {(data.forecast_14d || []).slice(0, 14).map((p, i) => (
            <tr key={i} style={{ borderBottom: '1px solid #334155' }}>
              <td style={{ padding: 4 }}>{p.date?.slice(5)}</td>
              <td style={{ padding: 4, textAlign: 'right' }}>{Math.round(p.balance).toLocaleString()}</td>
              <td style={{ padding: 4, textAlign: 'right', color: '#10B981' }}>+{Math.round(p.income).toLocaleString()}</td>
              <td style={{ padding: 4, textAlign: 'right', color: '#EF4444' }}>-{Math.round(p.expense).toLocaleString()}</td>
              <td style={{ padding: 4, textAlign: 'center' }}>{p.risk === 'red' ? '🔴' : p.risk === 'yellow' ? '🟡' : '🟢'}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default Brief;